/** CommerceTools web-channel keys: `{country}-web`, optionally prefixed (e.g. `PL-PL-web`). */
const WEB_CHANNEL_STORE_PATTERN = /^([A-Z]{2}-)+web$/i;

export const isWebChannelStoreId = (storeId: string): boolean =>
    WEB_CHANNEL_STORE_PATTERN.test(storeId);

/** Web-channel store keys are shown as "Online" on PLP store filters (all markets). */
export const resolvePlpStoreDisplayName = (storeId: string, name?: string): string => {
    if (isWebChannelStoreId(storeId)) return "Online";
    return name ?? storeId;
};
